export default import.meta.ROLLUP_FILE_URL_q5gMmjghmFBNcEx5LIsglw